import Sparkie from '@hotmart/sparkie'

const firebaseConfig = {
  apiKey: process.env.SPARKIE_FIREBASE_API_KEY,
  authDomain: process.env.SPARKIE_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.SPARKIE_FIREBASE_DATABASE_URL,
  projectId: process.env.SPARKIE_FIREBASE_PROJECT_ID,
  storageBucket: process.env.SPARKIE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.SPARKIE_FIREBASE_MESSAGING_SENDER_ID
}

const sparkie = new Sparkie({
  firebaseConfig,
  options: {
    conversationAPI: process.env.API_C3P0_CONVERSATION,
    authURL: `${process.env.API_C3P0_AUTH}/v1`
  }
})

type TSubscribeEventsActions = {
  cursorUpdated: Function
  messageReceived: Function
}

export const subscribeEvents = (actions: TSubscribeEventsActions) => {
  const { cursorUpdated, messageReceived } = actions

  if (cursorUpdated) {
    sparkie.on('cursors.update', cursorUpdated)
  }

  if (messageReceived) {
    sparkie.on('messages.create', messageReceived)
  }
}

export default sparkie
